<div class="container">
  <div class="card">
    <label for="linkInput" class="input-label">Notificacao de Renovacao por Creditos Automatico (NRCA):</label>
    <div class="card-content">
      <input type="text" id="linkInput" class="input-field" placeholder="Insira o link aqui" [value]="uriNRCA" [(ngModel)]="uriNRCA" />
      <button class="save-button" (click)="handleUpdateUriNRCA()"><mat-icon>save</mat-icon>Salvar</button>
    </div>
  </div>
</div>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>